import React, { useEffect, useState } from 'react';
import {
  DataGridGroup,
  useResponsiveParams,
  Text,
  Button,
  NotificationList,
} from 'quanta-ui';
import { useQuery } from '@apollo/client';
import { Link } from 'react-router-dom';
import {
  GET_DATE_TIME,
  GET_GENDER_LIST,
  LOB_PRODUCT_LIST,
  PAY_PREMIUM_LIST,
  SEND_PROPOSAL_PDF,
} from '../queries';
import { Loading, Error } from 'quanta-flows/modules/layout';
// import Error from '../../../../../lib/layout/error';
import { CurrencyFormater } from 'quanta-flows';
import { useParams } from 'react-router-dom';
import {
  faDownload,
  faExternalLinkAlt,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalViewBreakup from './modal-view-breakup';
// import useMutationQuery from '../../../../../lib/graphql/useMutationQuery';
// import useFetchQuery from '../../../../../lib/graphql/useFetchQuery';
import { useFetchQuery, useMutationQuery } from 'quanta-flows';

export default function ProposalSummary({
  data: dataBuyHealthPolicy,
  productName,
  planName,
  planCode,
}) {
  // console.log("Buy Health policy Details from custom proposal summary",buyHealthPolicy);
 // console.log(productName);
  const [alerts, setAlerts] = useState([]);
  const mutateQuery = useMutationQuery();
  const fetchQuery = useFetchQuery();
  const [showViewBreakup, setShowViewBreakup] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [mounted, setMounted] = useState(false);
  const params = useParams();
  const product_name = productName
    ? productName
    : params?.product_name;
  const plan_name = planName ? planName : params?.plan_name;
  const plan_code = planCode ? planCode : params?.plan_code;
  const product_code  ='2880'
  let repeat = useResponsiveParams({ for_mobile: 2, for_desktop: 2 });

  const {
    loading: loadingGenderList,
    error: errorGenderList,
    data: dataGenderList,
  } = useQuery(GET_GENDER_LIST, { fetchPolicy: 'cache-first' });

  const {
    loading: list_loading,
    error: error_list,
    data: ListDetails,
  } = useQuery(PAY_PREMIUM_LIST, {
    fetchPolicy: 'cache-first',
  });
  const {
    loading: loadingLobList,
    error: errorLobList,
    data: dataLobList,
  } = useQuery(LOB_PRODUCT_LIST, {
    fetchPolicy: 'cache-first',
  });
  const lob_code = '28';
  const lob_name = 'Health';

  useEffect(() => {
    let isMounted = true;
    if (
      dataBuyHealthPolicy &&
      dataGenderList &&
      ListDetails &&
      !mounted
    ) {
      setMounted(true);
    }
    return () => {
      isMounted = false;
    };
  }, [mounted, dataBuyHealthPolicy, dataGenderList, ListDetails]);

  const getBase64Var = (buyHealthPolicyData, getDateTimeData) => {
    const getInsuredDetailsObj = (
      insuredDetails,
      nomineeDetails,
      prevInsuranceDetails,
      medicalQuestionaire,
      planData,
      isHealthDeclarationSelected,
    ) => {
      let insuredDetailsResponseArr = [];
      insuredDetails.forEach((insured) => {
        const {
          ppcTestLevel,
          memberID,
          memberStatus,
          ...restInsured
        } = insured;
        let insuredObj = { ...restInsured };

        const nomineeObj = nomineeDetails?.find(
          (nominee) =>
            nominee?.relationship?.toLowerCase() ===
            insured?.relationship?.toLowerCase(),
        );
        const { relationship, ...restNomineeObj } = nomineeObj;
        insuredObj.nomineeDetails = {
          ...restNomineeObj,
          insuredRelationship: relationship,
        };

        const prevInsuranceInput = prevInsuranceDetails?.find(
          (prevInsured) =>
            prevInsured?.insuredRelationship?.toLowerCase() ===
            insured?.relationship?.toLowerCase(),
        );

        insuredObj.prevInsuranceInput = {
          prevInsurerName: prevInsuranceInput?.prevInsurerName,
          prevPolicyNo: prevInsuranceInput?.prevPolicyNo,
          prevPolicySI: prevInsuranceInput?.prevPolicySI,
          prevClaimLodged:
            prevInsuranceInput?.prevClaimLodged?.toLowerCase() ===
            'yes'
              ? true
              : false,
          claimAmount: prevInsuranceInput?.claimAmount,
          prevPolicyStartDate:
            prevInsuranceInput?.prevPolicyStartDate,
          prevPolicyEndDate: prevInsuranceInput?.prevPolicyEndDate,
          cbAmount: prevInsuranceInput?.cbAmount,
        };

        let medicalQuestionaireObj = isHealthDeclarationSelected
          ? medicalQuestionaire?.find(
              (m) =>
                m?.relationship?.toLowerCase() ===
                insured?.relationship?.toLowerCase(),
            )
          : { relationship: insured?.relationship, questions: [] };

        if (
          medicalQuestionaireObj &&
          medicalQuestionaireObj?.questions?.length > 0
        ) {
          medicalQuestionaireObj = {
            ...medicalQuestionaireObj,
            questions: medicalQuestionaireObj?.questions?.map(
              (question) => {
                return {
                  srNo: question?.srNo,
                  answer: question?.answer?.answerText,
                };
              },
            ),
          };
          medicalQuestionaireObj = {
            ...medicalQuestionaireObj,
            questions:
              medicalQuestionaireObj?.questions
                ?.find((q) => q?.srNo?.toLowerCase() === 'master')
                ?.answer?.toLowerCase() === 'no'
                ? medicalQuestionaireObj?.questions?.filter(
                    (q) => q?.srNo?.toLowerCase() !== 'master',
                  )
                : [],
          };
        }
        insuredObj.medicalQuestionaire = medicalQuestionaireObj
          ? medicalQuestionaireObj
          : { relationship: insured?.relationship, questions: [] };

        const { plans } = planData;
        insuredObj.addOnCovers = plans
          ?.find(
            (p) =>
              p?.name?.toLowerCase() === plan_name?.toLowerCase(),
          )
          ?.packs?.filter((pack) =>
            pack?.index?.includes(insured?.relationship),
          )
          .flatMap((pack) =>
            pack.addOnCovers.filter(
              (addOnCover) => addOnCover.selected,
            ),
          );

        if (!insuredObj.addOnCovers) {
          insuredObj.addOnCovers = [];
        }

        insuredDetailsResponseArr.push(insuredObj);
      });
      return insuredDetailsResponseArr;
    };
    const { crn, isNewCustomer,ciuType,isCRNVerified, ...restProposerMetaData } =
      buyHealthPolicyData?.proposerDetailsMeta;
    return {
      input: {
        proposerDetails: {
          ...restProposerMetaData,
          ...buyHealthPolicyData?.proposerDetails,
          isThinCustomer: false,
        },
        insuredDetails: getInsuredDetailsObj(
          buyHealthPolicyData?.insuredDetails,
          buyHealthPolicyData?.nomineeDetails,
          buyHealthPolicyData?.prevInsuranceDetails,
          buyHealthPolicyData?.medicalQuestionaire,
          buyHealthPolicyData?.planData,
          buyHealthPolicyData?.isHealthDeclarationSelected?.toLowerCase() ===
            'yes',
        ),
        plan: {
          name: plan_name,
          code: plan_code,
          covers:
          buyHealthPolicyData?.planData?.plans?.find(
            (plan) =>
              plan?.name?.toLowerCase() === plan_name?.toLowerCase(),
          )?.covers?.length > 0
            ? buyHealthPolicyData?.planData?.plans?.find(
                (plan) =>
                  plan?.name?.toLowerCase() ===
                  plan_name?.toLowerCase(),
              )?.covers
            : [],
        packs:
          buyHealthPolicyData?.planData?.plans?.find(
            (plan) =>
              plan?.name?.toLowerCase() === plan_name?.toLowerCase(),
          )?.packs?.length > 0
            ? buyHealthPolicyData?.planData?.plans?.find(
                (plan) =>
                  plan?.name?.toLowerCase() ===
                  plan_name?.toLowerCase(),
              )?.packs
            : [],
          premium: buyHealthPolicyData?.planData?.plans?.find(
            (plan) =>
              plan?.name?.toLowerCase() === plan_name?.toLowerCase(),
          )?.premium,
        },
        intermediary: {
          intermediaryCode: buyHealthPolicyData?.intermediaryDetails
            ?.code
            ? `${buyHealthPolicyData?.intermediaryDetails?.code}`
            : '',
          locationCode: buyHealthPolicyData?.intermediaryDetails
            ?.location
            ? `${buyHealthPolicyData?.intermediaryDetails?.location}`
            : '',
          fieldUserCode: buyHealthPolicyData?.intermediaryDetails
            ?.fieldUserCode
            ? `${buyHealthPolicyData?.intermediaryDetails?.fieldUserCode}`
            : '',
        },
        zone: buyHealthPolicyData?.quoteData?.location?.zone?.trim(),
        quotationType: buyHealthPolicyData?.quotationType,
        sumInsured: parseFloat(
          buyHealthPolicyData?.quoteData?.cover?.sum_insured,
        ),
        deductSumInsured: parseFloat(
          buyHealthPolicyData?.quoteData.deductSumInsured,
        ),
        startDate: getDateTimeData?.datetimeValue?.date,
        startTime: '00:00',
        coverType: buyHealthPolicyData?.quoteData?.cover?.type,
        tenure: buyHealthPolicyData?.quoteData?.cover?.tenure,
        proposalPaymentType: buyHealthPolicyData?.proposalPaymentType,
        isHealthDeclarationSelected:
          buyHealthPolicyData?.isHealthDeclarationSelected?.toLowerCase() ===
          'yes',
        quoteNumber: buyHealthPolicyData?.quoteNumber,
        productCode: product_code,
        policyNumber: buyHealthPolicyData?.quoteData?.policyNumber,
        employeeNumber:
          buyHealthPolicyData?.quoteData?.employeeNumber,
        proposerPincode:
          buyHealthPolicyData?.quoteData?.location?.pincode,
        /* Renew mandate */
        renewalMandateDetails: {
          renewalPaymentMandate:
            buyHealthPolicyData?.renewalMandateDetails
              ?.renewalPaymentMandate,
          renewalPaymentMandateTakenInNameOf:
            buyHealthPolicyData?.renewalMandateDetails
              ?.renewalPaymentMandateTakenInNameOf,
          termForMandateOpted:
            buyHealthPolicyData?.renewalMandateDetails
              ?.termForMandateOpted,
          typeOfDebit:
            buyHealthPolicyData?.renewalMandateDetails?.typeOfDebit,
          accountNumber:
            buyHealthPolicyData?.renewalMandateDetails?.accountNumber,
          destinationBankName:
            buyHealthPolicyData?.renewalMandateDetails
              ?.destinationBankName,
          destinationIfscCode:
            buyHealthPolicyData?.renewalMandateDetails
              ?.destinationIfscCode,
          destinationMicrCode:
            buyHealthPolicyData?.renewalMandateDetails
              ?.destinationMicrCode,
          destinationBranchName:
            buyHealthPolicyData?.renewalMandateDetails
              ?.destinationBranchName,
          mandateAmount: parseFloat(
            buyHealthPolicyData?.renewalMandateDetails?.mandateAmount,
          ),
          finalCollectionDate:
            buyHealthPolicyData?.renewalMandateDetails
              ?.finalCollectionDate,
          destinationBankAccountType:
            buyHealthPolicyData?.renewalMandateDetails
              ?.destinationBankAccountType,
        },
      },
      proposalNumber: buyHealthPolicyData?.proposalNumber,
    };
  };

  if (dataBuyHealthPolicy) {
    var buyHealthPolicy = dataBuyHealthPolicy?.buyHealthPolicy;
    var quoteData = buyHealthPolicy?.quoteData;
    var planData = buyHealthPolicy?.planData;
    var plans = planData?.plans;
  }

  if (dataGenderList) {
    var { genderList } = dataGenderList;
  }

  if (ListDetails) {
    var { ProposalPaymentTypeList } = ListDetails;
  }
  if (dataLobList) {
    var { lobProductList } = dataLobList;
  }

  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find((d) => d[`${searchType}`] === searchText)
      ? domainArr.find((d) => d[`${searchType}`] === searchText)[
          `${returnType}`
        ]
      : '';
  };

  let grid_data = [
    {
      grid_data: [
        buyHealthPolicy?.quoteNumber
          ? {
              label: (
                <div className="flex justify-start mt-2 mb-0.5">
                  <Text
                    type="label"
                    className="flex justify-end items-end h-full"
                  >
                    Quotation Number
                  </Text>
                  {/* <Text className="text-secondary flex items-center">
                    <FontAwesomeIcon
                      icon={faExternalLinkAlt}
                      className="cursor-pointer ml-2 text-xs"
                      onClick={(_) =>
                        window.open(
                          `/quote/saved/${buyHealthPolicy?.quoteNumber}`,
                        )
                      }
                    />
                  </Text> */}
                </div>
              ),
              colSpan: repeat,
              text: (
                <Link
                  to={`/quote/saved/${lob_code}/${
                    lobProductList?.find(
                      (lpl) =>
                        lpl?.lob_code?.toLowerCase() ===
                        lob_code?.toLowerCase(),
                    )?.lob_name
                  }/${product_code}/${product_name}/${
                    buyHealthPolicy?.quoteNumber
                  }`}
                >
                  <Text className="text-secondary underline">
                    {buyHealthPolicy?.quoteNumber}
                  </Text>
                </Link>
              ),     
            }
          : null,
        buyHealthPolicy?.proposalNumber
          ? {
              label: (
                <span className="text-primary">Proposal Number</span>
              ),
              colSpan: repeat,
              text: <Text>{buyHealthPolicy?.proposalNumber}</Text>,
            }
          : null,
        // buyHealthPolicy?.proposalStatus
        //   ? {
        //       label: (
        //         <span className="text-primary">Proposal Status</span>
        //       ),
        //       text: <Text>{buyHealthPolicy?.proposalStatus}</Text>,
        //       colSpan: repeat,
        //     }
        //   : null,
          {
            label: 'Partner',
            colSpan: repeat,
            text: (
              buyHealthPolicy?.intermediaryDetails?.intermediaryName?
              <Text>
                {buyHealthPolicy?.intermediaryDetails?.intermediaryName}
              </Text>:buyHealthPolicy?.intermediaryDetails?.intermediaryCode ? <Text>
                {buyHealthPolicy?.intermediaryDetails?.intermediaryCode}
              </Text>:<Text severity={'neutral'}>Not Captured</Text>
            ),
          },
          {
            label: 'Branch Office',
            colSpan: repeat,
            text: (
              buyHealthPolicy?.intermediaryDetails?.branchOfficeName?
              <Text>
                {buyHealthPolicy?.intermediaryDetails?.branchOfficeName}
              </Text>:buyHealthPolicy?.intermediaryDetails?.location?<Text>
                {buyHealthPolicy?.intermediaryDetails?.location}
              </Text>:<Text severity={'neutral'}>Not Captured</Text>
            ),
          },
          {
            label: 'Field User',
            colSpan: repeat,
            text: (
              buyHealthPolicy?.intermediaryDetails?.fieldUserName?
              <Text>
                {buyHealthPolicy?.intermediaryDetails?.fieldUserName}
              </Text>:buyHealthPolicy?.intermediaryDetails?.fieldUserCode?<Text>
                {buyHealthPolicy?.intermediaryDetails?.fieldUserCode}
              </Text>:<Text severity={'neutral'}>Not Captured</Text>
            ),
          },
        buyHealthPolicy?.proposalPaymentType
          ? {
              label: (
                <span className="text-primary">Proposal Type</span>
              ),
              text: (
                <>
                  {ProposalPaymentTypeList && (
                    <Text>
                      {getDomainData(
                        ProposalPaymentTypeList,
                        buyHealthPolicy.proposalPaymentType,
                        'code',
                        'value',
                      )}
                    </Text>
                  )}
                </>
              ),
              colSpan: repeat,
            }
          : null,
        plan_name
          ? {
              label: <span className="text-primary">Plan Name</span>,
              text: <Text>{plan_name}</Text>,
              colSpan: repeat,
            }
          : null,
        quoteData?.cover?.sum_insured
          ? {
              label: (
                <span className="text-primary">Sum Insured</span>
              ),
              text: (
                <Text>
                  {CurrencyFormater(quoteData?.cover?.sum_insured)}
                </Text>
              ),
            }
          : null,
        plans?.find((p) => p.name === plan_name)?.premium
          ?.totalPremium
          ? {
              label: (
                <span className="text-primary">
                  Annual Premium (inclusive of all taxes)
                </span>
              ),
              colSpan: 2,
              text: (
                <div className="flex justify-start space-x-2 mt-1">
                  <span>
                    <Text
                      type="larger"
                      severity="info"
                      className="mt-0.5"
                    >
                      {CurrencyFormater(
                        plans.find((p) => p.name === plan_name)
                          .premium.totalPremium,
                      )}
                    </Text>
                  </span>
                  <span className="mt-2.5">
                    <Text
                      severity="action"
                      type="label"
                      className="quanta_link cursor-pointer mt-1"
                      onClick={(_) => {
                        setShowViewBreakup(true);
                      }}
                    >
                      View Breakup
                    </Text>
                  </span>
                </div>
              ),
            }
          : null,
        {
          text: (
            <span className="flex flex-col items-end justify-end py-3 w-full h-full">
              <Button
                flat={true}
                type={'button'}
                disabled={
                  !dataBuyHealthPolicy?.buyHealthPolicy
                    ?.proposalNumber.length > 0 || loadingDownload
                }
                size="medium"
                className="w-full"
                onClick={async (_) => {
                  try {
                    let getDateTime = fetchQuery({
                      query: GET_DATE_TIME,
                    });
                    setAlerts([]);
                    setLoadingDownload(true);

                    let { data: getDateTimeData } = await getDateTime;

                    let proposalPDFBase64String = mutateQuery({
                      mutation: SEND_PROPOSAL_PDF,
                      variables: getBase64Var(
                        buyHealthPolicy,
                        getDateTimeData,
                      ),
                    });

                    let { data: dataBase64String } =
                      await proposalPDFBase64String;
                    const { sendProposalPDF } = dataBase64String;
                    const { base64Pdf: downloadBase64String } =
                      sendProposalPDF;
                    setLoadingDownload(false);

                    let byteCharacters = atob(
                      downloadBase64String.toString(),
                    );
                    let byteNumbers = new Array(
                      byteCharacters.length,
                    );
                    for (let i = 0; i < byteCharacters.length; i++) {
                      byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    let byteArray = new Uint8Array(byteNumbers);
                    let file = new Blob([byteArray], {
                      type: 'application/pdf;base64',
                    });
                    let fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                  } catch (error) {
                   // console.log(error);
                    setAlerts([
                      {
                        id: Date.now(),
                        content: (
                          <div className="flex flex-col w-full h-full">
                            <Text type="normal">{error.message}</Text>
                          </div>
                        ),
                        type: 'error',
                        timeout: null,
                        disableClose: false,
                      },
                    ]);
                    setLoadingDownload(false);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }
                }}
              >
                <FontAwesomeIcon
                  icon={loadingDownload ? faSpinner : faDownload}
                  className="mr-4"
                  spin={loadingDownload}
                  size="lg"
                />
                {loadingDownload
                  ? 'Downloading...'
                  : 'Download Proposal Form'}
              </Button>
            </span>
          ),
          colSpan: repeat,
        },
      ].filter((d) => d),
    },
  ];

  return (
    <>
      {list_loading || loadingGenderList ? (
        <Loading />
      ) : errorGenderList ? (
        <Error error={error_list || errorGenderList} />
      ) : (
        <div>
          <DataGridGroup
            data={grid_data}
            repeat={repeat}
            textType="label"
            titleType="title"
            titleSeverity="info"
            className="w-full"
            gap={0}
            gapX={16}
            isSeparatorRequired={false}
            gapY={2}
            spaceY={2}
            nullData={() => (
              <Text className="opacity-40">Not Captured</Text>
            )}
          />
          <ModalViewBreakup
            {...{
              showViewBreakup,
              setShowViewBreakup,
              selectedPlanTypeView: plan_name,
              product_name,
              genderList,
              quoteData: buyHealthPolicy?.quoteData,
              planData: buyHealthPolicy?.planData,
              title: 'Premium Breakup for Proposal',
            }}
          />
          <div>
            <NotificationList {...{ items: alerts }} />
          </div>
        </div>
      )}
    </>
  );
}
